// extracted by css-extract-rspack-plugin
export default {"boxWrap":"ProcedureNew__boxWrap--DTl5w"};